import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { switchMap } from "rxjs";
import { MyOrganizationService } from "../../features/organizations/my-organization/my-organization.service";
import { OrganizationsService } from "../../features/organizations/organizations.service";
import { ImagePreloadDirective } from "../../shared/directives/image-preload.directive";
import { SettingsService } from "../../shared/services/settings.service";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { MenuService } from "../../structure/menu/menu.service";

@Component({
  selector: "app-tile-menu",
  templateUrl: "./tile-menu.component.html",
  styleUrl: "./tile-menu.component.scss",
  imports: [TranslateDirective, NgIf, ImagePreloadDirective, NgFor, RouterLink, AsyncPipe],
})
export class TileMenuComponent implements OnInit {

logoNotLoaded() : void {
 this.logo = undefined; 
}

  readonly sections = this.menuService.getSections();

  logo?: string;
  constructor(
    private readonly settings: SettingsService,
    private readonly orgService: OrganizationsService,
    private readonly myOrgService: MyOrganizationService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly menuService: MenuService
  ) {}

  ngOnInit(): void {
    const id = this.settings.isLicensed ? this.settings.organizationId : this.settings.creatorOrganizationId;
    if (id) {
      this.myOrgService.changed
        .pipe(switchMap(() => this.orgService.getOrganizationLogoDownloadURL(id)))
        .subscribe((x) => {
          this.logo = x;
          this.changeDetector.detectChanges();
        });
    }
  }
}
